(() => {
  const openSources = () => {
    const source = document.getElementById('benefits-sources');
    const details = source?.querySelector('details');
    if (!details) return;
    details.open = true;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  };
  const revealSources = () => {
    if (location.hash === '#benefits-sources') openSources();
  };
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('a[href="#benefits-sources"]')) openSources();
  });
  window.addEventListener('hashchange', revealSources);
  document.addEventListener('shopify:section:load', revealSources);
  revealSources();
})();
